module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-container",
    class: {
      "show": _vm.show, "hidden": !_vm.show
    }
  }, [_c('div', {
    staticClass: "curved-div"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      " + _vm._s(_vm.loading) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "colour-magic"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch rotate"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1883e206!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/loader/Loader.vue
// module id = 356
// module chunks = 2